module.exports = __webpack_public_path__ + "static/media/ear.0b5c86fe.png";